import { Select, Tag } from "antd";
const tagRender = (props) => {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={ 'green' }
      onMouseDown={ onPreventMouseDown }
      closable={ closable }
      onClose={ onClose }
      style={ {
        marginRight: 3,
      } }
    >
      { label }
    </Tag>
  );
};
const BaseSelectWithSearch = (props) => {
  const mergedStyle = {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    ...props.style,
  };
  
  return (

    <Select
      style={ mergedStyle }
      placeholder={ props.placeholder }
      allowClear
      { ...props }
      showSearch={ true }
      optionFilterProp="label"
      filterOption={ (input, option) => String(option?.label ?? '').toLowerCase().includes(input.toLowerCase()) }
      options={ props.options }
      tagRender={ tagRender }
    />

  )
}

export default BaseSelectWithSearch
